module.exports = __webpack_public_path__ + "media/images/photolive-0e9660235b055dded3917b6b3eef0a84.png";